<template>
    <div class="right_details">
        <h4 class="title">合约{{ row.instrument_id }}</h4>
    
        <div class="warpper2">
            <div class="warpper-inner warpper-inner-price">
                <div class="mt">
                    <p>最新</p>
                    <P>{{ row.price }}</P>
                </div>
                <div class="mt">
                    <p>开盘</p>
                    <P>{{ row.open_price }}</P>
                </div>
                <div class="mt">
                    <p>最高</p>
                    <P>{{ row.highest_price }}</P>
                </div>
                <div class="mt">
                    <p>最低</p>
                    <P>{{ row.lowest_price }}</P>
                </div>
                <div class="mt">
                    <p>前收</p>
                    <P>{{ row.pre_close_price }}</P>
                </div>
                <div class="mt">
                    <p>前结</p>
                    <P>{{ row.pre_settlement_price }}</P>
                </div>
                <div class="mt">
                    <p>涨停</p>
                    <P>{{ row.upper_limit_price }}</P>
                </div>
                <div class="mt">
                    <p>跌停</p>
                    <P>{{ row.lower_limit_price }}</P>
                </div>
            </div>
            <div class="warpper-inner warpper-inner-buySell">
                <div class="mt">
                    <p>卖五</p>
                    <P :class="decideColor(row.ask_price[4])">{{ row.ask_price[4] ?  row.ask_price[4]  : '--'}}</P>
                    <p>{{ row.ask_volume[4] ?  row.ask_volume[4]  : '--'}}</p>
                </div>
                <div class="mt">
                    <p>卖四</p>
                    <P :class="decideColor(row.ask_price[3])">{{ row.ask_price[3] ?  row.ask_price[3] : '--'}}</P>
                    <p>{{ row.ask_volume[3] ?  row.ask_volume[3]  : '--'}}</p>
                </div>
                <div class="mt">
                    <p>卖三</p>
                    <P :class="decideColor(row.ask_price[2])">{{ row.ask_price[2] ?  row.ask_price[2] : '--' }}</P>
                    <p>{{ row.ask_volume[2] ?  row.ask_volume[2] : '--' }}</p>
                </div>
                <div class="mt">
                    <p>卖二</p>
                    <P :class="decideColor(row.ask_price[1])">{{ row.ask_price[1] ?  row.ask_price[1] : '--' }}</P>
                    <p>{{ row.ask_volume[1] ?  row.ask_volume[1] : '--' }}</p>
                </div>
                <div class="mt pb bottom-border">
                    <p>卖一</p>
                    <P :class="decideColor(row.ask_price[0])">{{ row.ask_price[0] ?  row.ask_price[0] : '--' }}</P>
                    <p>{{ row.ask_volume[0] ?  row.ask_volume[0] : '--' }}</p>
                </div>

                <div class="mt">
                     <p>买一</p>
                     <P :class="decideColor(row.bid_price[0])">{{ row.bid_price[0] ? row.bid_price[0] : '--' }}</P>
                     <p>{{ row.bid_volume[0]  ? row.bid_volume[0] : '--' }}</p>
                </div>
                <div class="mt">
                     <p>买二</p>
                     <P :class="decideColor(row.bid_price[1])">{{ row.bid_price[1] ? row.bid_price[1] : '--'  }}</P>
                     <p>{{ row.bid_volume[1] ? row.bid_volume[1] : '--'  }}</p>
                </div>
                <div class="mt">
                     <p>买三</p>
                     <P :class="decideColor(row.bid_price[2])">{{ row.bid_price[2] ? row.bid_price[2] : '--'  }}</P>
                     <p>{{ row.bid_volume[2] ? row.bid_volume[2] : '--'  }}</p>
                </div>
                <div class="mt">
                     <p>买四</p>
                     <P :class="decideColor(row.bid_price[3])">{{ row.bid_price[3] ? row.bid_price[3] : '--'  }}</P>
                     <p>{{ row.bid_volume[3] ? row.bid_volume[3] : '--'  }}</p>
                </div>
                <div class="mt">
                     <p>买五</p>
                     <P :class="decideColor(row.bid_price[4])">{{ row.bid_price[4] ? row.bid_price[4] : '--'  }}</P>
                     <p>{{ row.bid_volume[4] ? row.bid_volume[4] : '--'  }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/assets/eventBus.js'
export default {
    data() {
        return {
            row: {
                ask_price: [0,0,0,0,0],
                ask_volume: [0,0,0,0,0],
                bid_price: [0,0,0,0,0],
                bid_volume: [0,0,0,0,0],
            },
        }
    },
    created() {
        bus.$on("lookDeatails1", this.lookDeatails)
    },
    computed: {
        times() {
            if(!this.row.update_time) {
                return ''
            }
            let str = this.row.update_time.toString()
            let time = ''
            if(str.length >= 6) {
                time = str.substring(0,2) + ":" + str.substring(2,4) + ":" + str.substring(4,6)
            } else {
                time = str.substring(0,1) + ":" + str.substring(1,3) + ":" + str.substring(3,5)
            }
            return time
        },
    },
    destroyed() {
        this.row = {}
    },
    beforeDestroy() {
         bus.$off("lookDeatails1")
    },
    methods: {
        lookDeatails(row) {
            this.row = row
        },
        decideColor(price) {
            if(!price || price == 0) return ''
            price = Number(price)
            let settle = Number(this.row.pre_settlement_price)
            if(price  == settle) return ''
            if(price < settle) {
                return 'green'
            } else {
                return 'red'
            }
        }
    },
    props: ['configs']
}
</script>

<style scoped>
.right_details {
    width: 500px;
    height: 300px;
    box-sizing: border-box;
    padding: 0 20px;
}

.right_details .title {
    width: 460px;
    margin: 0 auto;
    height: 40px;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    background: #eee;
    border-radius: 10px;
}

.right_details .warpper2 {
    margin-top: 10px;
    display: flex;
}

.right_details .warpper2 .warpper-inner {
    width: 50%;
}

.right_details .warpper2 .warpper-inner div {
    display: flex;
}
.right_details .warpper2 .warpper-inner-price div > p:first-of-type {
    width: 40%;
}
.right_details .warpper2 .warpper-inner-price div > p:last-of-type {
    width: 60%;
}

.right_details .warpper2 .warpper-inner-buySell div > p:nth-child(1) {
    width: 20%;
}
.right_details .warpper2 .warpper-inner-buySell div > p:nth-child(2) {
    width: 40%;
}
.right_details .warpper2 .warpper-inner-buySell div > p:nth-child(3) {
    width: 40%;
}

.mt {
    margin-top: 5px;
}
.mb {
    margin-bottom: 5px;
}
.pt {
    padding-top: 5px;
}
.pb {
    padding-bottom: 5px;
}

.right_details .warpper>.row {
    width: 460px;
    display: flex;
}
.bottom-border {
    border-bottom: 1px solid #000;
}

.buySell {
    display: flex;
}

.right_details .warpper .sell>.row,.right_details .warpper .buy>.row {
    width: 230px;
    display: flex;
}

.right_details .warpper .row>div {
    display: flex;
    width: 50%;
}

.right_details .warpper .row>div p {
    width: 50%;
}

.right_details .updateTime {
    margin-top: 10px;
}

.green {
    color: green;
}
.red {
    color: red;
}

</style>
